// extracted by mini-css-extract-plugin
export var parcelRow = "_ta-0";